module.exports = __webpack_public_path__ + "img/memoji-7.c2de9db4.svg";